import { ReactComponent as CloseIcon } from "src/images/close-icon.svg";
import { media } from "src/styles/mixins";
import styled from "styled-components";

export const BackgroundWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;

  padding: 32px 16px;

  background-color: ${({ theme }) => theme.colors.modalBackground};
`;

export const SummaryWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  max-width: 1100px;
  min-width: 350px;
  max-height: 100%;
  min-height: 350px;
  width: 100%;

  padding: 32px 16px;

  background-color: ${({ theme }) => theme.colors.background};
  border: 2px solid ${({ theme }) => theme.colors.primary};
  border-radius: 16px;
  box-sizing: border-box;

  h2 {
    text-align: center;
    font-size: ${({ theme }) => theme.fonts.sizes.s};
    font-weight: ${({ theme }) => theme.fonts.weights.bolder};
    line-height: ${({ theme }) => theme.fonts.lineHeights.s};
    margin-bottom: 48px;
  }

  ${({ theme }) => media.up("MOBILE")`
    padding: 48px 16px;
    margin: 48px 16px;
    h2 {
      font-size: ${theme.fonts.sizes.l};
    }
  `}
`;

export const ElementsWrapper = styled.div<{ isEmpty: boolean }>`
  width: 100%;
  min-height: 220px;

  display: flex;
  flex-direction: column;

  background-color: ${({ theme }) => theme.colors.background};
  border: 2px solid ${({ theme }) => theme.colors.accent};
  border-radius: 16px;
  box-sizing: border-box;

  overflow-y: auto;

  ${media.up("LAPTOP")`
    width: 90%;
  `}

  ${({ isEmpty }) =>
    isEmpty ? "justify-content: center; h2 { margin-bottom: 0; }" : null}
`;

export const StyledCloseIcon = styled(CloseIcon)`
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
`;
